var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7954 21.9998H6.00915C6.00915 21.9998 3.3673 22.0738 3 18.9577V10.0555C4.61515 9.6752 7.0209 9.3449 7.77549 5.34501L8.34015 2C13.8831 2 11.8917 6.2759 11.8917 7.15296C11.796 7.96629 12.4003 8.75917 13.7351 8.75917H15.6356M15.5542 8.75917H19.0615C21.6332 8.75917 21.6332 12.0694 19.0615 12.0694H15.5542C12.9825 12.0694 12.9825 8.75917 15.5542 8.75917ZM14.1903 12.0694H19.1252C21.6248 12.0694 21.6251 15.3796 19.1252 15.3796H14.1903C11.6907 15.3796 11.6904 12.0694 14.1903 12.0694ZM13.3527 15.3796H18C20.4517 15.3796 20.4518 18.6898 18 18.6898H13.3527C10.901 18.6898 10.901 15.3796 13.3527 15.3796ZM13.6803 18.6898H16.9589C19.2081 18.6898 19.2083 22 16.9589 22H13.6803C11.4311 22 11.4309 18.6898 13.6803 18.6898Z",
    stroke: "currentColor",
    strokeWidth: "",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatch);
export default __webpack_public_path__ + "static/media/match.6155eb6ee463cf727b25334fc95bb68e.svg";
export { ForwardRef as ReactComponent };